import iconMap from 'icon-map'
import React, { useState } from 'react'
import { CustomColorsRef, IconSizes } from 'types/general'

interface IconProps {
  icon: string
  size?: IconSizes
  color?: string
  hoverColor?: string
  className?: string
}

const Icon: React.FC<IconProps> = ({
  icon,
  size = IconSizes.MD,
  color = CustomColorsRef.Primary,
  hoverColor,
  className,
}) => {
  const [isHovered, setIsHovered] = useState(false)

  const IconComponent = iconMap[icon as keyof typeof iconMap]

  if (!IconComponent) {
    console.warn(`Icon "${icon}" not found in iconMap`)
    return null
  }

  const fillColor = isHovered && hoverColor ? hoverColor : color

  return (
    <IconComponent
      className={className}
      width={size}
      height={size}
      style={{
        fill: fillColor,
        transition: 'fill 0.3s ease',
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    />
  )
}

export default Icon
